<script>
    import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
</script>
<Cell style="text-align: left"><b><slot/></b></Cell>